<--诊所订单统计-->
<template>
    <div>
        <div style="padding:0 20px">
            <div class="top">
                <el-date-picker
                        v-model="date"
                        type="daterange"
                        align="right"
                        @change="dateChange"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                </el-date-picker>
                <el-select
                        size="small"
                        placeholder="诊所" style="width: 170px" v-model="query.hospitalNo" @change="getDate">
                    <el-option key="" label="全部" value=""></el-option>
                    <el-option
                            v-for="item in hospitalList"
                            :key="item.hospitalNo"
                            :label="item.hospitalName"
                            :value="item.hospitalNo">
                    </el-option>
                </el-select>
            </div>
            <div class="chart-box">
                <div id="count"></div>
                <div id="totalAmt"></div>
            </div>
            <el-table :data="list"
                      :header-cell-style="{'padding-left': '10%'}"
                      :cell-style="{'padding-left': '10%'}">
                <el-table-column label="诊所" sortable>
                    <template slot-scope="scope">
                        <div>{{scope.row.hospitalName}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="count" label="接诊数"></el-table-column>
                <el-table-column prop="totalAmt" label="订单金额"></el-table-column>
                <el-table-column prop="drugAmt" label="药品金额"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="queryAgentDayOrderSum(scope.row.hospitalNo)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
            <el-dialog title="详情" :visible.sync="dayVisible" width="730px"
                       :close-on-click-modal="false" >
                <el-table :data="listDay"
                          :header-cell-style="{'padding-left': '10%'}"
                          :cell-style="{'padding-left': '10%'}">
                    <el-table-column prop="count" label="接诊数"></el-table-column>
                    <el-table-column prop="totalAmt" label="订单金额"></el-table-column>
                    <el-table-column prop="drugAmt" label="药品金额"></el-table-column>
                    <el-table-column prop="gmtCreated" label="日期"></el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :current-page="pageNumDay"
                            :page-size="pageSizeDay"
                            :total="totalDay"
                            @current-change="handlePageChangeDay"
                    ></el-pagination>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { Chart } from '@antv/g2';
    import getDate from "../common/dataFormat";
    import revert from "../common/revert";
    export default {
        data() {
            return {
                dayVisible:false,
                list:[],
                listDay:[],
                authorization: localStorage.getItem('authorization'),
                hospitalList: [],
                agentList: [],
                date: '',
                pickerOptions: {
                    shortcuts: [{
                        text: '本周',
                        onClick(picker) {
                            const end = getDate.getCurrWeekDays().endtime;
                            const start = getDate.getCurrWeekDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '上周',
                        onClick(picker) {
                            const end = getDate.getLastWeekDays().endtime;
                            const start = getDate.getLastWeekDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '本月',
                        onClick(picker) {
                            const end = getDate.getCurrMonthDays().endtime;
                            const start = getDate.getCurrMonthDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '上月',
                        onClick(picker) {
                            const end = getDate.getLastMonthDays().endtime;
                            const start = getDate.getLastMonthDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                radioDate: '本周',
                handleDate: '',
                chartData: [
                ],
                chartDayData:[],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 0,
                pageNumDay: 1,
                pageSizeDay: 10,
                totalDay: 0,
                query: {
                    endTime: "",
                    startTime: "",
                    hospitalNo:""
                }
            }
        },
        mounted() {

        },
        methods: {
            queryAgentDayOrderSum(agentNo){
                this.dayVisible=true
                this.query.agentNo=agentNo;
                this.axios.post('/api-s/10009/100191', this.query, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data != null) {
                            this.chartDayData = res.data.data
                            this.total=this.chartDayData.length
                            let start = this.pageSizeDay * (this.pageNumDay - 1)
                            let end = this.pageSizeDay * this.pageNumDay
                            this.listDay = []
                            for (let i = start; i < end; i++) {
                                if (i < end) {
                                    if ( this.chartDayData[i]) {
                                        this.listDay.push( this.chartDayData[i])
                                    } else {
                                        break
                                    }
                                }
                            }

                        } else {
                            this.chartDayData = []
                        }

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getDate() {
                this.agentList = []
                this.chartData = {}
                this.axios.post('/api-b/10018/100095/1/1000', {
                        queryParam: "",
                        auditStatus: ""
                    },
                    {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length > 0) {
                            this.hospitalList = res.data.data.list
                        } else {
                            this.hospitalList = []
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
                this.axios.post('/api-s/10009/100190', this.query, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data != null) {
                            this.chartData = res.data.data
                            this.total=this.chartData.length
                            let start = this.pageSize * (this.pageNum - 1)
                            let end = this.pageSize * this.pageNum
                            this.list = []
                            for (let i = start; i < end; i++) {
                                if (i < end) {
                                    if ( this.chartData[i]) {
                                        this.list.push( this.chartData[i])
                                    } else {
                                        break
                                    }
                                }
                            }
                            this.createNumberChart(this.list);
                            //this.createValueChart(this.list);

                        } else {
                            this.chartData = []
                        }

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            createNumberChart(data) {
                document.getElementById("count").innerHTML="<div id=\"count\"></div>";
                let chart = new Chart({
                    container: 'count',
                    autoFit: false,
                    width: 780,
                    height: 420,
                });
                chart.data(data);
                chart.interval().position('hospitalName*count').color('#d0e6ff')
                chart.scale({
                    count:{
                        min: 0,
                        nice: true,
                        alias: '接诊数',
                    },
                });

                chart.render();
            }/*,
            createValueChart(data) {
                document.getElementById("totalAmt").innerHTML="<div id=\"totalAmt\"></div>";
                let chart = new Chart({
                    container: 'totalAmt',
                    autoFit: false,
                    width: 780,
                    height: 420,
                });
                chart.data(data);
                chart.interval().position('hospitalName*totalAmt').color('#d0fedc')
                chart.scale({
                    value:{
                        min: 0,
                        nice: true,
                        alias: '接诊金额',
                    },
                });

                chart.render();
            }*/,
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                let start = this.pageSize * (this.pageNum - 1)
                let end = this.pageSize * this.pageNum
                this.list = []
                for (let i = start; i < end; i++) {
                    if (i < end) {
                        if ( this.chartData[i]) {
                            this.list.push( this.chartData[i])
                        } else {
                            break
                        }
                    }
                }
             //   this.createNumberChart(this.list);
             //   this.createValueChart(this.list);
            },   // 表格换页
            handlePageChangeDay(val) {
                this.pageNumDay = val;
                let start = this.pageSizeDay * (this.pageNumDay - 1)
                let end = this.pageSizeDay * this.pageNumDay
                this.listDay = []
                for (let i = start; i < end; i++) {
                    if (i < end) {
                        if ( this.chartDayData[i]) {
                            this.list.push( this.chartDayData[i])
                        } else {
                            break
                        }
                    }
                }
            },
            dateChange(val) {
                this.query.startTime = val[0]
                this.query.endTime = val[1]
                this.getDate()
            }
        },
        created() {
            this.date = [
                getDate.getCurrWeekDays().starttime, getDate.getCurrWeekDays().endtime
            ]
            this.query.endTime = getDate.getCurrWeekDays().endtime;
            this.query.startTime = getDate.getCurrWeekDays().starttime;
            this.getDate()
        }
    }

</script>
<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 13px;
        height: 52px;
    }
    .then {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height:112px;
        background:rgba(251,254,255,1);
        border-radius:4px;
        border:1px solid rgba(210,237,255,1);
        margin-bottom: 20px;
    }
    .then-in {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        height: 70px;
        color:rgba(102,102,102,1);
        font-size: 14px;
    }
    .then-in-number {
        font-size:30px;
        font-weight:bold;
        color:rgba(97,167,255,1);
    }
    .line {
        width:1px;
        height:112px;
        background: rgba(210,237,255,1);
    }
    .chart-box{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        padding: 30px 0;
        width: 100%;
        height:423px;
        background:rgba(251,254,255,1);
        border-radius:8px;
        border:1px solid rgba(210,237,255,1);
        margin-bottom: 20px;
    }
</style>